/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { useState, useContext, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import ContactTableLoader from "./ContactTableLoader";
import CheckBox from "Components/common/CheckBox";
import PaginationComponent from "Components/common/PaginationComponent";
import { ContactSearchTableContext } from "./ContactSearchTable";
import { userDetail } from "Stores/userDetail";
import {
  getContactPurchasePayload,
  showPaginationLimitReachPopup,
  verifyBulkActionPerformedAndAllow,
  DISCOVER_TOTAL_COUNT_CAP,
  formatCompanyRevenueDisplay,
  formatCompanySizeDisplay
} from "../DataSearchUtils";
import { Utils } from "Utils/utils";
import { dataSearchState } from "../state";
import SocialLinks from "./SocialLinks";
import { isPurchaseEnabled } from "../DataSearchUtils";
import NoFilterApplied from "./NoFilterApplied";
import { showPhonePurchasePopup } from "../DataSearchUtils";
import { toasterState } from "Components/common/toaster";
import ContactRangeSelection from "./ContactRangeSelection";
import { MXP_EVENT, PAGE_TYPE } from "Static/MixPanelEvents";
import { priceRangeSliderPopupState } from "Components/popup/PriceRangeSliderPopup/main";



const LIST_BUILDER_MAX_SELECTABLE = 10000;
const DISCOVER_MAX_SELECTABLE = 1000;

const SearchTableBody = observer(() => {
  const contactBodyRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const isListBuilder = (location.pathname || "").includes("/list-builder");
  const MAX_SELECTABLE_CONTACTS = isListBuilder ? LIST_BUILDER_MAX_SELECTABLE : DISCOVER_MAX_SELECTABLE;
  const [horizontalScrollState, setHorizontalScrollState] = useState({
    canScroll: false,
    moreRight: false
  });
  const {
    tableLoading = false,
    setTableLoading = () => { },
    contactData = {},
    allTableContactChecked = false,
    setAllTableContactChecked = () => { },
    setContactData = () => { },
    resetAllDynamicState = () => { }
  } = useContext(ContactSearchTableContext);

  const updateHorizontalScrollState = () => {
    const el = contactBodyRef?.current;
    if (!el) return;
    const canScroll = el.scrollWidth > el.clientWidth;
    const moreRight = canScroll && el.scrollLeft + el.clientWidth < el.scrollWidth - 2;
    setHorizontalScrollState(prev =>
      prev.canScroll !== canScroll || prev.moreRight !== moreRight
        ? { canScroll, moreRight }
        : prev
    );
  };

  useEffect(() => {
    updateHorizontalScrollState();
    const el = contactBodyRef?.current;
    if (!el) return;
    const ro = new ResizeObserver(updateHorizontalScrollState);
    ro.observe(el);
    return () => ro.disconnect();
  }, [contactData?.contacts, tableLoading]);

  useEffect(() => {
    const el = contactBodyRef?.current;
    if (!el) return;
    const onWheel = e => {
      if (e.deltaX === 0) return;
      const atLeft = el.scrollLeft <= 1;
      const atRight = el.scrollLeft >= el.scrollWidth - el.clientWidth - 1;
      const swipingLeft = e.deltaX < 0;
      const swipingRight = e.deltaX > 0;
      if ((atLeft && swipingRight) || (atRight && swipingLeft)) {
        return;
      }
      if ((atLeft && swipingLeft) || (atRight && swipingRight)) {
        e.preventDefault();
      }
    };
    el.addEventListener("wheel", onWheel, { passive: false });
    return () => el.removeEventListener("wheel", onWheel);
  }, []);

  // Reset horizontal scroll only when a new search/page has finished loading (not when a single contact is updated in place)
  const prevTableLoadingRef = useRef(tableLoading);
  useEffect(() => {
    const didJustFinishLoading = prevTableLoadingRef.current === true && tableLoading === false;
    prevTableLoadingRef.current = tableLoading;
    if (didJustFinishLoading) {
      const el = contactBodyRef?.current;
      if (el) el.scrollLeft = 0;
    }
  }, [contactData?.contacts, tableLoading]);

  const onContactBodyScroll = () => {
    updateHorizontalScrollState();
  };

  const shouldShowInitialPage =
    dataSearchState?.showInitialPage || !dataSearchState?.isFilterApplied;

  // When switching back to initial list-builder state, always reset body scroll.
  // Without this, previous table scroll can leave the hero/title visually clipped.
  useEffect(() => {
    if (!shouldShowInitialPage) return;
    const el = contactBodyRef?.current;
    if (!el) return;
    const resetToTop = () => {
      el.scrollTop = 0;
      el.scrollLeft = 0;
    };
    resetToTop();
    requestAnimationFrame(resetToTop);
    const timeoutId = setTimeout(resetToTop, 80);
    const onResize = () => resetToTop();
    window.addEventListener("resize", onResize);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", onResize);
    };
  }, [shouldShowInitialPage]);

  const {
    paginationLimit = 0,
    bulkPurchaseEnabled = false,
    bulkPurchaseLimit = 0
  } = userDetail?.userFeatureFlag || {};

  const [paginationForceRender, setPaginationForceRender] = useState(false); // Hack: used to reset pagintation to previous value

  const markSelectedContact = (value = false, contactId = "", limit = 0) => {
    if (["all", "custom", "bulk"].includes(contactId?.toLowerCase())) {
      if (!value && allTableContactChecked) {
        deselectAllCheckedContacts();
        dataSearchState.setRangeSelected("");
      } else {
        const numLimit = Array.isArray(limit)
          ? limit.length
          : typeof limit === "number"
            ? limit
            : (parseInt(limit, 10) || 0);
        dataSearchState.setRangeSelected({ type: contactId, limit: numLimit });
        setAllTableContactChecked(value);
        toggleSelectContacts("", numLimit);
      }
    } else {
      const performSelectContactAction = () => {
        if (value) {
          let tempSelectCount =
            dataSearchState.selectedContactData?.length || 0;
          let pageCount =
            dataSearchState?.contactTableData?.contacts?.length || 0;
          let isSelectAll = tempSelectCount === pageCount - 1;
          isSelectAll &&
            dataSearchState.setRangeSelected({ type: "all", limit: pageCount });
          setAllTableContactChecked(isSelectAll);
        } else {
          setAllTableContactChecked(false);
          dataSearchState.setRangeSelected("");
        }
        toggleSelectContacts(contactId);
      };
      if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
        verifyBulkActionPerformedAndAllow(performSelectContactAction);
      } else {
        performSelectContactAction();
      }
    }
  };

  const deselectAllCheckedContacts = () => {
    contactData?.contacts &&
      contactData.contacts.map(value => {
        value.isSelected = !value.isSelected;
      });
    setContactData(contactData);
    setAllTableContactChecked(false);
    dataSearchState.setSelectedContactData([]);
  };

  const toggleSelectContacts = (contactId = "", limit = 0) => {
    const clonedData = Utils.createObjWithoutRef(contactData);
    if (clonedData?.contacts && Utils.hasObject(clonedData?.contacts)) {
      let count = 0;
      clonedData.contacts.map(value => {
        if (contactId) {
          value?.id === contactId && (value.isSelected = !value.isSelected);
        } else {
          // Selecting all the contacts in the table
          if (limit > 0) {
            value.isSelected = limit > count;
            count++;
          } else {
            value.isSelected = true;
          }
        }
      });
    }
    setContactData(clonedData);
    updateSelectedDataInStore(clonedData);
  };

  const updateSelectedDataInStore = data => {
    const tempArr = [];
    data?.contacts?.map(value => {
      if (value?.isSelected) {
        tempArr.push(value.id);
      }
    });
    dataSearchState.setSelectedContactData(tempArr);
  };

  const paginate = pageObj => {
    if (tableLoading) return;
    const performPagination = async () => {
      const pageNo = pageObj?.selected + 1 || 1;
      if (paginationLimit >= pageNo) {
        Utils.mixpanelTrack(MXP_EVENT.PAGINATION_CLICKED, {
          pageType: PAGE_TYPE.discover,
          pageNo
        });
        setTableLoading(true);
        resetAllDynamicState();
        dataSearchState.setCurrentPage(pageNo);
        dataSearchState.setIsFromSeoPage(false);
        const ran = await dataSearchState.searchPageData();
        if (!ran) {
          setTableLoading(false);
          return;
        }
        contactBodyRef &&
          contactBodyRef.current &&
          contactBodyRef.current.scrollTo({
            top: 0,
            behavior: "smooth"
          });
      } else {
        Utils.mixpanelTrack(MXP_EVENT.PAGINATION_LIMIT_REACHED_POPUP_SHOWN, {
          pageType: PAGE_TYPE.discover,
          pageNo
        });
        setPaginationForceRender(true);
        showPaginationLimitReachPopup(history);
        setTimeout(() => {
          setPaginationForceRender(false);
        }, 0);
      }
    };
    if (["bulk", "custom"].includes(dataSearchState?.rangeSelected?.type)) {
      verifyBulkActionPerformedAndAllow(performPagination, () => {
        setPaginationForceRender(true);
        setTimeout(() => {
          setPaginationForceRender(false);
        }, 0);
        dataSearchState.setCurrentPage(dataSearchState.currentPage);
      });
    } else {
      performPagination();
    }
  };

  const toggleContactPurchaseLoader = (
    contactId,
    type,
    toggleValue,
    hasData = false
  ) => {
    if ((type || "").toLowerCase() === "emailandphone") {
      toggleSinglePurchaseLoader(contactId, "email", toggleValue, hasData);
      toggleSinglePurchaseLoader(contactId, "phone", toggleValue, hasData);
      return;
    }
    toggleSinglePurchaseLoader(contactId, type, toggleValue, hasData);
  };

  const singleContactPurchaseCbk = async (contactId, type, contact) => {
    const { firstName = "", lastName = "", companyName = "" } = contact || {};
    dataSearchState.setSinglePurchaseContactName(
      [firstName, lastName].filter(Boolean).join(" ")
    );
    dataSearchState.setContactCompanyName(companyName);
    if (type.toLowerCase() === "phone") {
      Utils.mixpanelTrack(MXP_EVENT.FIND_PHONE_NUMBER_CLICKED, {
        pageType: PAGE_TYPE.discover,
        contactName: `${contact?.firstName} ${contact?.lastName}`,
        companyName: contact?.companyName
      });
    }
    toggleContactPurchaseLoader(contactId, type, true);
    const scrollEl = contactBodyRef?.current;
    const savedScrollTop = scrollEl?.scrollTop ?? 0;
    const savedScrollLeft = scrollEl?.scrollLeft ?? 0;
    try {
      if (type.toLowerCase() === "email") {
        await dataSearchState.purchaseSingleContactFindEmail(contact, contactId);
      } else if (type.toLowerCase() === "phone") {
        await dataSearchState.purchaseSingleContactFindPhone(contact, contactId);
      } else if (type.toLowerCase() === "emailandphone") {
        await dataSearchState.purchaseSingleContactFindEmail(contact, contactId);
        await dataSearchState.purchaseSingleContactFindPhone(contact, contactId);
      } else {
        const payload = getContactPurchasePayload([contactId], null, type);
        await dataSearchState.purchaseSingleContact(payload, history);
      }
    } finally {
      const restoreScroll = () => {
        const el = contactBodyRef?.current;
        if (el) {
          el.scrollTop = savedScrollTop;
          el.scrollLeft = savedScrollLeft;
        }
      };
      requestAnimationFrame(restoreScroll);
      setTimeout(restoreScroll, 50);
      setTimeout(restoreScroll, 150);
      setTimeout(() => {
        dataSearchState.setIsFindPhoneEmailClicked(false);
      }, 1000);
      toggleContactPurchaseLoader(contactId, type, false, true);
    }
  };

  const toggleSinglePurchaseLoader = (
    contactId,
    type,
    toggleValue,
    hasData = false
  ) => {
    dataSearchState.setContactId(contactId);
    hasData
      ? dataSearchState.setFoundData(true)
      : dataSearchState.setFoundData(false);
    type.toLowerCase() === "email"
      ? dataSearchState.setFindDataType("email")
      : dataSearchState.setFindDataType("phone");
    const clonedData = Utils.createObjWithoutRef(
      dataSearchState?.contactTableData
    );
    clonedData?.contacts &&
      clonedData.contacts.map(value => {
        if (value?.id === contactId) {
          if (type === "phone") {
            value.singlePurchasePhoneLoading = toggleValue;
          } else {
            value.singlePurchaseEmailLoading = toggleValue;
          }
        }
      });
    if (clonedData?.contacts?.length > 0) {
      clonedData.contacts[0].isSelected = false;
    }
    dataSearchState.setContactTableData(clonedData);
    setContactData(clonedData);
  };

  const adjustHeight = () => {
    return contactData?.totalPages > 1 ? "adjustPaginationSpace" : "";
  };

  const totalContacts = contactData?.totalContacts ?? 0;
  const totalPages = contactData?.totalPages ?? 0;
  const pageLimit = dataSearchState?.pageLimit || 10;
  const displayTotalPages =
    totalContacts > DISCOVER_TOTAL_COUNT_CAP && totalPages > 0
      ? Math.min(totalPages, Math.ceil(DISCOVER_TOTAL_COUNT_CAP / pageLimit))
      : totalPages;
  const displayCurrentPage = Math.min(dataSearchState?.currentPage || 1, displayTotalPages || 1);

  const hasTableData = () => {
    return (!dataSearchState?.selectedContactData?.length > 0 &&
      !contactData?.totalContacts > 0) ||
      !dataSearchState.isFilterApplied
      ? "noTableSearchData"
      : "";
  };

  return (
    <>
      <section
        className={`searchTableBody ${hasTableData()} ${adjustHeight()}`}
      >
        {/* Same shell as Companies tab: scroll lives on .contactBody so empty state scrolls and does not inherit bad scrollTop on .searchTableBody */}
        <div className="contactBodyWrapper">
          {horizontalScrollState.canScroll && horizontalScrollState.moreRight && (
            <div
              className="contactBody-scrollHint"
              aria-hidden
            />
          )}
          <div
            className={`contactBody ${horizontalScrollState.canScroll ? "contactBody--scrollable" : ""}`}
            ref={contactBodyRef}
            onScroll={onContactBodyScroll}
          >
            {shouldShowInitialPage ? (
              <NoFilterApplied />
            ) : (
              <>
                <TableTitle
                  totalContacts={contactData?.totalContacts}
                  totalPages={contactData?.totalPages}
                  markSelectedContact={markSelectedContact}
                  bulkPurchaseLimit={bulkPurchaseLimit}
                  bulkPurchaseEnabled={bulkPurchaseEnabled}
                  deselectAllCheckedContacts={deselectAllCheckedContacts}
                  customBulkPurchaseLimitCap={isListBuilder ? LIST_BUILDER_MAX_SELECTABLE : DISCOVER_MAX_SELECTABLE}
                />
                <TableContent
                  markSelectedContact={markSelectedContact}
                  singleContactPurchaseCbk={singleContactPurchaseCbk}
                  toggleSelectContacts={toggleSelectContacts}
                />
              </>
            )}
          </div>
        </div>
        {!shouldShowInitialPage && (
          <PaginationComponent
            callback={paginate}
            loading={tableLoading}
            totalPages={displayTotalPages}
            currentPage={displayCurrentPage}
            forceRender={paginationForceRender}
          />
        )}
      </section>
    </>
  );
});

const TOP_SELECTABLE_CONTACTS = 1000; // "Select top 1,000" — unchanged for List Builder and Discover

const TableTitle = observer(props => {
  const {
    bulkPurchaseLimit = 0,
    bulkPurchaseEnabled = false,
    totalContacts = 0,
    totalPages = 0,
    markSelectedContact = () => { },
    deselectAllCheckedContacts = () => { },
    customBulkPurchaseLimitCap = 1000
  } = props || {};

  const {
    allTableContactChecked = false,
    setAllTableContactChecked = () => { },
    tableLoading = false
  } = useContext(ContactSearchTableContext);

  let pagedContacts = dataSearchState?.contactTableData?.contacts?.length || 0;
  let topPurchaseLimit =
    totalContacts <= TOP_SELECTABLE_CONTACTS
      ? totalContacts
      : TOP_SELECTABLE_CONTACTS;
  let customBulkPurchaseLimit = Math.min(
    customBulkPurchaseLimitCap,
    totalContacts > 0 ? totalContacts : customBulkPurchaseLimitCap
  );

  const [showRangeSelector, setShowRangeSelector] = useState(false);
  const [isCustomRangeSelector, setCustomRangeSelector] = useState(false);
  const selectAllTriggerRef = useRef(null);

  const toggleSelectAction = (value = false, id = "") => {
    if (totalPages > 1) {
      setShowRangeSelector(true);
      if (allTableContactChecked) {
        dataSearchState.setRangeSelected("");
        deselectAllCheckedContacts();
        setAllTableContactChecked(false);
      }
    } else {
      markSelectedContact(value, id, pagedContacts);
    }
  };

  return (
    <div className="tableHeader">
      <div className="stickyLeftCol" role="presentation">
        <div className="ctSelectAll" ref={selectAllTriggerRef}>
          {!tableLoading && totalContacts > 0 && (
            <>
              <CheckBox
                key={"all"}
                id={"all"}
                checked={allTableContactChecked}
                cbk={toggleSelectAction}
              />
              {(showRangeSelector && (
                <ContactRangeSelection
                  triggerRef={selectAllTriggerRef}
                  bulkPurchaseEnabled={bulkPurchaseEnabled}
                  allTableContactChecked={allTableContactChecked}
                  pagedContacts={pagedContacts}
                  topPurchaseLimit={topPurchaseLimit}
                  customBulkPurchaseLimit={customBulkPurchaseLimit}
                  isCustomRangeSelector={isCustomRangeSelector}
                  setCustomRangeSelector={setCustomRangeSelector}
                  setShowRangeSelector={setShowRangeSelector}
                  markSelectedContact={markSelectedContact}
                />
              )) ||
              ""}
            </>
          )}
        </div>
        <div className="nameCont">Contact</div>
      </div>
      <div className="titleCont">Title</div>
      <div className="companyCont">Company</div>
      <div className="contactInfoCont">Contact Info</div>
      <div className="contactLocationCont">Contact Location</div>
      <div className="deptCont">Department</div>
      <div className="seniorityCont">Seniority</div>
      <div className="locationCont">Company Location</div>
      <div className="sizeCont">Company Size</div>
      <div className="revenueCont">Annual Revenue</div>
      <div className="industryCont">Industry</div>
      <div className="companyTypeCont">Company Type</div>
    </div>
  );
});

const TableContent = observer(props => {
  const {
    singleContactPurchaseCbk = () => { },
    markSelectedContact = () => { },
    toggleSelectContacts = () => { }
  } = props || {};

  const { contactData = [], tableLoading } = useContext(
    ContactSearchTableContext
  );
  const data = contactData?.contacts || [];
  const [sessionUnavailableMap, setSessionUnavailableMap] = useState({});

  const getName = (fName, lName) => {
    return fName && lName ? `${fName} ${lName}` : fName || lName || "--";
  };

  // Format raw department function strings: "Media_and_communication" → "Media And Communication"
  const formatDeptFunction = (str = "") => {
    return str
      .replace(/_/g, " ")
      .replace(/\b\w/g, c => c.toUpperCase());
  };

  // Seniority id → display label (matches filter options)
  const SENIORITY_LABEL = {
    founder: "Founder", owner: "Owner", partner: "Partner", c_suite: "C-Suite",
    vp: "VP", director: "Director", head: "Head", manager: "Manager",
    senior: "Senior", "mid-level": "Mid-Level", entry: "Entry", intern: "Intern"
  };

  // Company type id → display label (matches filter options)
  const COMPANY_TYPE_LABEL = {
    PRIVATELY_HELD: "Privately Held", SELF_OWNED: "Self Owned", SELF_EMPLOYED: "Self Employed",
    PARTNERSHIP: "Partnership", PUBLIC_COMPANY: "Public Company", NON_PROFIT: "Non-Profit",
    EDUCATIONAL: "Educational", GOVERNMENT_AGENCY: "Government Agency"
  };

  const formatSeniority = (id = "") => SENIORITY_LABEL[id] || formatDeptFunction(id);
  const formatCompanyType = (id = "") => {
    if (id == null || id === "") return "";
    return COMPANY_TYPE_LABEL[id] || formatDeptFunction(String(id).replace(/_/g, " "));
  };

  // Fix common acronyms that get incorrectly title-cased by the API
  const formatIndustry = (str = "") => {
    if (!str) return str;
    const acronyms = { "It ": "IT ", " It ": " IT ", "Hr ": "HR ", " Hr ": " HR ", "Ai ": "AI ", " Ai ": " AI ", "Saas": "SaaS", "B2b": "B2B", "B2c": "B2C", "Roi": "ROI", "Crm": "CRM", "Erp": "ERP", "Iot": "IoT", "Pr ": "PR ", " Pr ": " PR " };
    let result = str;
    Object.entries(acronyms).forEach(([wrong, correct]) => {
      result = result.split(wrong).join(correct);
    });
    // Also fix "It" at the very end of a string
    if (result.endsWith(" It")) {
      result = result.slice(0, -2) + "IT";
    }
    return result;
  };

  const getLocation = address => {
    if (address?.[0]) {
      if (typeof address[0] === "string") {
        return address[0];
      }
      const { state = "", country = "" } = address[0];
      let location = state ? state + ", " : "";
      location += country || "";
      return location;
    }
  };

  const getFirstElem = (arr = []) => {
    if (arr?.length > 0) {
      return arr.filter(item => item && item !== "null" && item)?.[0] || "";
    }
    return "";
  };

  const copyEmail = (val, msg, type = "") => {
    if (val) {
      Utils.mixpanelTrack(
        MXP_EVENT[
        type === "email" ? "COPY_EMAIL_CLICKED" : "COPY_PHONE_CLICKED"
        ],
        {
          pageType: PAGE_TYPE.discover
        }
      );
      Utils.copyToClipboard(val);
      toasterState.setToastMsg(msg, "success");
    }
  };

  const getPrimaryPhoneNumber = (
    directPhone = [],
    mobilePhone = [],
    otherPhone = []
  ) => {
    const raw =
      getFirstElem(directPhone) ||
      getFirstElem(mobilePhone) ||
      getFirstElem(otherPhone) ||
      "";

    if (raw && typeof raw === "object" && raw.number != null) {
      return String(raw.number);
    }
    if (typeof raw === "string") {
      return raw;
    }
    return "";
  };

  const markUnavailableAfterAttempt = (contactId = "", attemptedType = "") => {
    const latest =
      dataSearchState?.contactTableData?.contacts?.find(c => c?.id === contactId) || {};
    const hasEmailNow = !!latest?.emailOwned;
    const hasPhoneNow = !!latest?.phoneOwned;
    const phoneUnavailableNow = !!latest?.phoneNumberUnavailable;
    const attempt = (attemptedType || "").toLowerCase();
    const isBoth = attempt === "emailandphone";

    setSessionUnavailableMap(prev => {
      const current = prev?.[contactId] || { email: false, phone: false };
      const next = { ...current };
      if (isBoth || attempt === "email") {
        next.email = !hasEmailNow;
      }
      if (isBoth || attempt === "phone") {
        next.phone = !hasPhoneNow || phoneUnavailableNow;
      }
      return { ...prev, [contactId]: next };
    });
  };

  const renderContactInfoCell = (
    contact,
    id,
    singlePurchaseEmailLoading,
    singlePurchasePhoneLoading
  ) => {
    const {
      email = "",
      emailOwned = false,
      phoneOwned = false,
      directPhone = [],
      mobilePhone = [],
      otherPhone = [],
      phoneNumberUnavailable = false
    } = contact || {};
    const primaryPhone = getPrimaryPhoneNumber(directPhone, mobilePhone, otherPhone);
    const hasOwnedPhone = phoneOwned && !phoneNumberUnavailable && !!primaryPhone;
    const sessionUnavailable = sessionUnavailableMap?.[id] || {};
    const emailUnavailable = !emailOwned && !!sessionUnavailable?.email;
    const phoneUnavailable = phoneNumberUnavailable || (!hasOwnedPhone && !!sessionUnavailable?.phone);
    const canRevealEmail = !emailOwned && !emailUnavailable;
    const canRevealPhone = !hasOwnedPhone && !phoneUnavailable;
    const canRevealBoth = canRevealEmail && canRevealPhone;

    const isAnyLoading = singlePurchaseEmailLoading || singlePurchasePhoneLoading;

    const onRevealClick = async revealType => {
      await singleContactPurchaseCbk(id, revealType, contact);
      markUnavailableAfterAttempt(id, revealType);
    };

    const renderSegmentBtn = (label, icon, type, isEnabled, isLoading) => (
      <button
        type="button"
        className={`contactInfoSegmentBtn ${isEnabled ? "enabled" : "disabled"} ${
          isLoading ? "loading" : ""
        }`}
        disabled={!isEnabled || isAnyLoading}
        onClick={() => isEnabled && onRevealClick(type)}
      >
        <>
          <i className="material-icons contactInfoSegmentIcon">{icon}</i>
          {isLoading ? <span className="contactInfoSegmentSpinner" /> : <span>{label}</span>}
        </>
      </button>
    );

    const showInlinePhoneButtonBelowEmail =
      (emailOwned || emailUnavailable) &&
      canRevealPhone &&
      !hasOwnedPhone &&
      !phoneUnavailable;

    const segmentButtons = [];
    if (canRevealEmail && canRevealPhone) {
      segmentButtons.push(
        renderSegmentBtn(
          "Email",
          "mail_outline",
          "email",
          true,
          singlePurchaseEmailLoading
        ),
        renderSegmentBtn(
          "Phone",
          "phone",
          "phone",
          true,
          singlePurchasePhoneLoading
        ),
        renderSegmentBtn(
          "Both",
          "contacts",
          "emailAndPhone",
          true,
          singlePurchaseEmailLoading && singlePurchasePhoneLoading
        )
      );
    } else if (canRevealEmail) {
      segmentButtons.push(
        renderSegmentBtn(
          "Email",
          "mail_outline",
          "email",
          true,
          singlePurchaseEmailLoading
        )
      );
    } else if (canRevealPhone && !showInlinePhoneButtonBelowEmail) {
      segmentButtons.push(
        renderSegmentBtn(
          "Phone",
          "phone",
          "phone",
          true,
          singlePurchasePhoneLoading
        )
      );
    }

    return (
      <div className="contactInfoStack">
        {segmentButtons.length > 0 && (
          <div className="contactInfoSegmented">{segmentButtons}</div>
        )}

        {(emailOwned || emailUnavailable) && (
          <div
            className={`contactInfoItem ${emailOwned ? "copyHint" : ""}`}
            data-copy-hint={emailOwned ? "Click to copy" : ""}
            onClick={() =>
              emailOwned &&
              copyEmail(email, "Email address copied successfully.", "email")
            }
          >
            <i className="material-icons contactInfoIcon">mail_outline</i>
            {emailOwned ? (
              <span className="contactInfoText" title={email}>{email}</span>
            ) : (
              <span className="notFoundText">Unavailable</span>
            )}
          </div>
        )}

        {showInlinePhoneButtonBelowEmail && (
          <div className="contactInfoInlineAction">
            {renderSegmentBtn(
              "Phone",
              "phone",
              "phone",
              true,
              singlePurchasePhoneLoading
            )}
          </div>
        )}

        {(hasOwnedPhone || phoneUnavailable) && (
          <div
            className={`contactInfoItem ${hasOwnedPhone ? "copyHint" : ""}`}
            data-copy-hint={hasOwnedPhone ? "Click to copy" : ""}
            onClick={() =>
              hasOwnedPhone &&
              copyEmail(primaryPhone, "Phone Number copied successfully", "phone")
            }
          >
            <i className="material-icons contactInfoIcon">phone</i>
            {hasOwnedPhone ? (
              <span className="contactInfoText" title={primaryPhone}>{primaryPhone}</span>
            ) : (
              <span className="notFoundText">Unavailable</span>
            )}
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    if (data?.length > 0) {
      dataSearchState.setHasData(true);
    }
  }, [data]);

  return (
    <div className="tableContent">
      {tableLoading ? (
        <ContactTableLoader />
      ) : data?.length > 0 ? (
        <>
          {data?.map(contact => {
            const {
              id = "",
              firstName = "",
              lastName = "",
              email = "",
              title = "",
              department = [],
              departmentFunctions = [],
              companyLinkedIn = "",
              companyLogo = "",
              companyFacebook = "",
              companyTwitter = "",
              companyWebsite = "",
              address = [],
              companyAddress = [],
              companyName = "",
              companyDomain = "",
              linkedIn = "",
              facebook = "",
              twitter = "",
              github = "",
              phoneOwned = false,
              emailOwned = false,
              directPhone = [],
              mobilePhone = [],
              otherPhone = [],
              companyPhone = [],
              companySize = "",
              companyRevenue = "",
              companyLocation = "",
              companyIndustry = "",
              contactLocation = "",
              seniority = "",
              companyType = "",
              confidenceScore = "",
              isSelected = false,
              singlePurchaseEmailLoading = false,
              singlePurchasePhoneLoading = false,
              hasShow = false,
              phoneNumberUnavailable = false,
              profilePic = ""
            } = contact || {};
            const location = getLocation(address || companyAddress);
            const name = getName(firstName, lastName);

            return (
              <div className="contact" key={contact?.id} has-data="true">
                <div className="stickyLeftCol" role="presentation">
                  <div className="ctSelectAll">
                    <CheckBox
                      key={id}
                      id={id}
                      checked={isSelected}
                      cbk={markSelectedContact}
                    />
                  </div>
                  <div className="nameCont dataContainer">
                    <span className="contactAvatar">
                      {/* Initials always rendered as base layer */}
                      <span className="avatarInitials">
                        {(firstName?.[0] || "").toUpperCase()}{(lastName?.[0] || "").toUpperCase()}
                      </span>
                      {/* Profile pic overlaid on top; if it fails to load, initials show through */}
                      {profilePic && (
                        <img
                          src={profilePic}
                          alt={`${firstName} ${lastName}`}
                          onError={e => { e.target.style.display = "none"; }}
                        />
                      )}
                    </span>
                    <div className="nameTextWrapper">
                      {name && (
                        <span className="darkText name" title={name}>
                          {name}
                        </span>
                      )}
                      {(linkedIn || twitter || facebook) && (
                        <span className="contactNameSocialLinks">
                          <SocialLinks
                            companyDomain=""
                            linkedIn={linkedIn}
                            facebook={facebook}
                            twitter={twitter}
                            showOnlyLinkedInAndTwitter={true}
                            id={`personal-${id}`}
                          />
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="titleCont dataContainer">
                  {title && (
                    <span className="darkText title" title={title}>
                      {title}
                    </span>
                  )}
                </div>
                <div className="companyCont dataContainer companyContRow">
                  <span className="companyAvatar">
                    {companyLogo ? (
                      <img
                        src={companyLogo}
                        alt={companyName || ""}
                        onError={e => { e.target.style.display = "none"; }}
                      />
                    ) : (
                      <span className="companyAvatarInitial">
                        {(companyName?.[0] || companyDomain?.[0] || "").toUpperCase()}
                      </span>
                    )}
                  </span>
                  <div className="companyTextWrapper">
                    {(companyName || companyDomain) && (
                      <span
                        className="darkText companyName"
                        title={companyName || companyDomain}
                      >
                        {companyName || companyDomain}
                      </span>
                    )}
                    {(companyWebsite || companyDomain || companyLinkedIn) && (
                      <SocialLinks
                        companyDomain={companyWebsite || companyDomain}
                        linkedIn={companyLinkedIn}
                        facebook={companyFacebook}
                        twitter={companyTwitter}
                        companyNumber={getFirstElem(companyPhone)}
                        id={id}
                      />
                    )}
                  </div>
                </div>
                <div className="contactInfoCont dataContainer">
                  {renderContactInfoCell(
                    contact,
                    id,
                    singlePurchaseEmailLoading,
                    singlePurchasePhoneLoading
                  )}
                </div>
                <div className="contactLocationCont dataContainer">
                  <span className="darkText" title={contactLocation}>
                    {contactLocation || "--"}
                  </span>
                </div>
                <div className="deptCont dataContainer">
                  {departmentFunctions?.length > 0 ? (
                    <span className="darkText" title={departmentFunctions.map(formatDeptFunction).join(", ")}>
                      {departmentFunctions.map(formatDeptFunction).join(" · ")}
                    </span>
                  ) : <span className="darkText">--</span>}
                </div>
                <div className="seniorityCont dataContainer">
                  <span className="darkText" title={formatSeniority(seniority)}>
                    {seniority ? formatSeniority(seniority) : "--"}
                  </span>
                </div>
                <div className="locationCont dataContainer">
                  <span className="darkText" title={companyLocation}>
                    {companyLocation || "--"}
                  </span>
                </div>
                <div className="sizeCont dataContainer">
                  <span className="darkText" title={formatCompanySizeDisplay(companySize) || companySize}>
                    {formatCompanySizeDisplay(companySize) || "--"}
                  </span>
                </div>
                <div className="revenueCont dataContainer">
                  <span className="darkText" title={formatCompanyRevenueDisplay(companyRevenue) || companyRevenue}>
                    {formatCompanyRevenueDisplay(companyRevenue) || "--"}
                  </span>
                </div>
                <div className="industryCont dataContainer">
                  <span className="darkText" title={formatIndustry(companyIndustry)}>
                    {formatIndustry(companyIndustry) || "--"}
                  </span>
                </div>
                <div className="companyTypeCont dataContainer">
                  <span className="darkText" title={formatCompanyType(companyType)}>
                    {companyType ? formatCompanyType(companyType) : "--"}
                  </span>
                </div>
              </div>
            );
          })}
        </>
      ) : (
        <div className="noContactFound lightText">No Contacts Found</div>
      )}
    </div>
  );
});

export { SearchTableBody };
export default SearchTableBody;
